import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import SubscribeForm from 'components/forms/SubscribeForm';

import { subscribeOperations } from 'ducks/subscribers';

const SubscribeFormContainer = ({ id, theme }) => {
	const dispatch = useDispatch();

	const onSubmit = useCallback((formData) => {
		dispatch(subscribeOperations.submitSubscribeForm(formData));
	}, []);

	return <SubscribeForm id={id} theme={theme} onSubmit={onSubmit} />;
};

SubscribeFormContainer.propTypes = {
	id: PropTypes.string.isRequired,
	theme: PropTypes.oneOf(['air'])
};

export default SubscribeFormContainer;
